<template>
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="日期范围">
          <el-date-picker size="small" v-model="searchForm.create_time" type="daterange" value-format="yyyy-MM-dd"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户昵称">
          <el-input size="small" v-model="searchForm.nick_name" placeholder="请输入用户昵称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="order_no" label="订单号" width="180"></el-table-column>
        <el-table-column prop="giftCard.name" label="礼品卡名称" width="120">
          <template slot-scope="scope">
            {{ scope.row.giftCard && scope.row.giftCard.name ? scope.row.giftCard.name : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="order_price" label="支付金额" width="100">
          <template slot-scope="scope">
            ${{ scope.row.order_price }}
          </template>
        </el-table-column>
        <el-table-column prop="user.nickName" label="购买用户" width="120">
          <template slot-scope="scope">
            {{ scope.row.user && scope.row.user.nickName ? scope.row.user.nickName : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="pay_status" label="支付状态" width="100">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.pay_status === 1 ? 'success' : 'info'">
              {{ scope.row.pay_status === 1 ? '已支付' : '未支付' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="购买时间" width="160"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="showDetail(scope.row)" type="text" size="small">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
        :total="totalDataNumber">
      </el-pagination>
    </div>

    <!--详情弹窗-->
    <el-dialog title="销售记录详情" :visible.sync="detailVisible" width="500px">
      <div v-if="detailRow" class="detail-content">
        <p><span class="label">订单号：</span>{{ detailRow.order_no }}</p>
        <p><span class="label">卡号：</span>{{ (detailRow.giftCardInstance && detailRow.giftCardInstance.card_no) || '-' }}</p>
        <p><span class="label">礼品卡名称：</span>{{ detailRow.giftCard && detailRow.giftCard.name ? detailRow.giftCard.name : '-' }}</p>
        <p><span class="label">面值：</span>${{ detailRow.gift_card_value }}</p>
        <p><span class="label">支付金额：</span>${{ detailRow.order_price }}</p>
        <p><span class="label">支付状态：</span>{{ detailRow.pay_status === 1 ? '已支付' : '未支付' }}</p>
        <p><span class="label">支付时间：</span>{{ detailRow.pay_time || '-' }}</p>
<!--        <p><span class="label">交易号：</span>{{ detailRow.transaction_id || '-' }}</p>-->
        <p><span class="label">购买用户：</span>{{ detailRow.user && detailRow.user.nickName ? detailRow.user.nickName : '-' }}</p>
        <p><span class="label">创建时间：</span>{{ detailRow.create_time }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import GiftCardApi from '@/api/gift_card/gift_card.js';

export default {
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 10,
      totalDataNumber: 0,
      curPage: 1,
      searchForm: {
        create_time: '',
        order_no: '',
        nick_name: ''
      },
      detailVisible: false,
      detailRow: null
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let self = this;
      let Params = { ...self.searchForm };
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      if (Params.create_time && Params.create_time.length === 2) {
        Params.date_start = Params.create_time[0];
        Params.date_end = Params.create_time[1];
      }
      self.loading = true;
      GiftCardApi.salesRecord(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = (data.data && data.data.list && data.data.list.data) ? data.data.list.data : [];
          self.totalDataNumber = (data.data && data.data.list && data.data.list.total) ? data.data.list.total : 0;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    showDetail(row) {
      this.detailRow = row;
      this.detailVisible = true;
    },
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    }
  }
};
</script>

<style scoped>
.detail-content p {
  margin: 8px 0;
}
.detail-content .label {
  color: #909399;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/gift_card/sales_record/index.vue